import React from "react";
//#region types
import { EditableFormInnerProps, GenericFormSection } from "models/propTypes/genericFormProps";
import { FormGridLayout } from "models/propTypes/basePropTypes";
//#endregion
//#region components
import useCheckVisibility from "./hooks/useCheckVisibility";
import useGetHasValueCountWithContext from "./hooks/useGetHasValueCountWithContext";
import useCheckHasEditableField from "./hooks/useCheckHasEditableField";
import ReadOnlyFormControlLayout from "./rowLayouts/readOnlyFormControlLayout";
import ReadOnlyFormInnerFields from "./readOnlyFormInnerFields";
//#endregion

function ReadOnlyFormInner<T extends Record<string, any>>(props: EditableFormInnerProps<T>) {
  const { fields } = props;
  const { getFieldHidden } = useCheckVisibility<T>();
  const { getHasValueCount } = useGetHasValueCountWithContext<T>();
  const { getHasEditableField } = useCheckHasEditableField<T>();

  const formGridLayout = (
    props.formGridLayout
      ? { ...props.formGridLayout }
      : {
          label: 3,
          message: false,
        }
  ) as FormGridLayout;

  return (
    <>
      {Array.isArray(fields) ? (
        (fields as GenericFormSection<T>[]).map((section, index) =>
          !getFieldHidden(section.hidden) && (getHasValueCount(section) || getHasEditableField(section)) ? (
            <ReadOnlyFormControlLayout
              key={section.label}
              label={section.label}
              icon={section.icon}
              inline={props.inline}
              formGridLayout={formGridLayout}
            >
              {<ReadOnlyFormInner<T> {...props} fields={section.innerFields ?? []} />}
            </ReadOnlyFormControlLayout>
          ) : (
            <React.Fragment key={`readOnlySection-${index}`}></React.Fragment>
          )
        )
      ) : (
        <ReadOnlyFormInnerFields {...props} fields={fields} />
      )}
    </>
  );
}

export default ReadOnlyFormInner;
